import { useEffect, useRef } from 'react';

export const useThrottledCallback = (
  callback: (...args: any[]) => void,
  delay = 500,
) => {
  const lastExecutedRef = useRef(0);
  const timeoutRef = useRef<NodeJS.Timeout>(undefined);
  const argsRef = useRef<any[]>([]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (...args: any[]) => {
    argsRef.current = args;
    const now = Date.now();
    const elapsed = now - lastExecutedRef.current;

    if (elapsed >= delay) {
      lastExecutedRef.current = now;
      callback(...args);
    } else {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        lastExecutedRef.current = Date.now();
        callback(...argsRef.current);
      }, delay - elapsed);
    }
  };
};
